import MarketPolicies from './MarketPolicies';

export default MarketPolicies;
